import * as actionTypes from './type';
import axios from 'axios';
import { requestShowLoader, requestHideLoader } from '../Global/action';
import { handleCheckPermission } from '../../Utility/rolepermissionHelper';
import {  defaultmenuLabel, teampermissionList } from '../../Utility/constant';
import history from '../../Utility/history';
import { publicRoutesPath } from '../../Routes';
import { sessionExpiredDialog } from '../../Utility/sessionExpired';
import { handleRequestGetAllLookup } from '../lookup/action';
import { handleRequestGetAllClientData } from '../Internationalise/action';
import { searchRequestData } from '../../Utility/apiHelper';
const headerReq = () => {
    return {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
        }
    }
}

const headerOrderReq = (token) => {
    return {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            // "Authorization": `Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbjIiLCJleHAiOjE2OTkwOTQwNjMsImlhdCI6MTY5OTA3NjA2M30.ndfegN3TLz-7KA-rmAVhezOjm1YS_-UCESn8JjOJebsTvFC1UMrY59QCihCORGfgK9QitMMpjLAUN0IErFM17w`
        }
    }
}


export const requestgetcurrenctuser = (token) => async(dispatch) => {
    try {
        
        const responseData = await axios.get(`${process.env.REACT_APP_BASE_URL}logged-in`, headerOrderReq(token));

        var specificRoleuserdetails = null;

        var organizationLabel= null;

        const currentUser = responseData?.data;
        currentUser.is_firstuser = true;
        if(currentUser) {
            let specificRole = [];
           
            specificRoleuserdetails = await handleCheckPermission(currentUser?.authorities);
            organizationLabel = defaultmenuLabel;

            if(currentUser?.resetPassword === true) {
                
                // history.push(`${publicRoutesPath?.FIRST_USER_PASSWORD_SETUP}`);
                
                // dispatch({
                //     type: actionTypes?.RECEIVED_CURRENT_USER,
                //     payload: {logeddata: responseData?.data, rolebasedData: specificRoleuserdetails, organizationLabel: organizationLabel}
                // })

                history.push({
                    pathname: `${publicRoutesPath?.FIRST_USER_PASSWORD_SETUP}`,
                    state: {
                        token: token,
                        currentUserData: responseData?.data
                    }
                })

            } else {

                 localStorage.setItem('accessToken', token);
           
                dispatch({
                    type: actionTypes?.RECEIVED_CURRENT_USER,
                    payload: {logeddata: responseData?.data, rolebasedData: specificRoleuserdetails, organizationLabel: organizationLabel}
                })

                dispatch(handleRequestGetAllClientData(currentUser?.client?.id, true));
    
                dispatch(handleRequestGetAllLookup(token, currentUser?.client?.id));
       
               

            }

            return currentUser?.client?.id
    
        } else {
            return currentUser?.client?.id
        }

       
    } catch(error) {
        if(error?.response?.status == 401) {
            sessionExpiredDialog();
        }
    }
}


export const handleUpdatePermissionSet = () => (dispatch) => {

    dispatch({
        type: actionTypes.UPDATE_CURRENT_USER_PERMISSION
    })

    dispatch({
        type: actionTypes?.CLER_TEAM_EMPTY
    })
}   



export const requestGetUserList=(queryparams) => async (dispatch)=>{
    try{

        dispatch({
        type: actionTypes.REQUEST_GET_USER
    })
    
    const clientSearchUrl = `${process.env.REACT_APP_BASE_URL}users`;
    
    const responsedata = await searchRequestData(queryparams , clientSearchUrl , false)
    dispatch({
        type: actionTypes.RECEIVED_SEARCHED_USER,
        payload : responsedata?.data
    })
    }
    catch(error){

    }


}